export default {"src":"/_next/static/media/ra-departure.cb0f70fb.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};